export const DEFAULT_THUMBNAIL_WIDTH = 160
export const DEFAULT_THUMBNAIL_HEIGHT = 110

export const THUMBNAIL_PIXEL_RATIO = 2

export const THUMBNAIL_RENDER_VERSION = [
  'v8',
  'camera:saved',
  'background:document',
  'bounds:document',
  `scale:${THUMBNAIL_PIXEL_RATIO}`,
].join('|')

export function thumbnailRenderDimensions(width: number, height: number): { width: number; height: number } {
  return {
    width: Math.max(1, Math.floor(width * THUMBNAIL_PIXEL_RATIO)),
    height: Math.max(1, Math.floor(height * THUMBNAIL_PIXEL_RATIO)),
  }
}

export function thumbnailMetaCoversSize(meta: { width?: number; height?: number }, width: number, height: number): boolean {
  return typeof meta.width === 'number'
    && typeof meta.height === 'number'
    && meta.width >= width
    && meta.height >= height
}
